// extracted by mini-css-extract-plugin
export var sliderRange = "_pe-2";
export var sliderRoot = "_pe-0";
export var sliderThumb = "_pe-3";
export var sliderTrack = "_pe-1";